import { render, staticRenderFns } from "./FiveNav.vue?vue&type=template&id=20cf8f78"
import script from "./FiveNav.vue?vue&type=script&lang=js"
export * from "./FiveNav.vue?vue&type=script&lang=js"
import style0 from "./FiveNav.vue?vue&type=style&index=0&id=20cf8f78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports